module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft-52074ad47445b22b7414b1479ee6e311.png";